// External library imports
import { get as lodashGet, set as lodashSet, keys as lodashKeys } from 'lodash';
// Css module imports
import bidClasses from '../../Bidding.module.css';
import CustomTooltip from '../../../../../components/CustomToolTip/CustomTooltip';
import { getColumnWithSlotSize } from '../../../../../utils/biddingHelper';
import { momentTimeFormater } from '../../../../../utils/timeHelper';
import Typography from '../../../../../components/Typography/Typography';
import { useEffect, useState } from 'react';

const BundleBidCapacity = ({ data }) => {
    const panicHours = lodashGet(data, ['panicHours'], []);
    const length = lodashGet(data, ['overall'], []).length || 24;
    const slots = Array.from({ length: length }, (__, i) => i);
    const columns = getColumnWithSlotSize(slots, 8);
    const bidDate = data.bidDate;
    const indivisualBids = data.indivisualBids;
    const instances = {};
    lodashGet(data, ['pairs'], []).map((el) => {
        lodashSet(instances, [el.instanceId], el.instanceName);
    });

    const [capacity, setCapacity] = useState([]);

    useEffect(() => {
        if (lodashKeys(instances).length) getCapacity();
    }, [instances]);

    const getCapacity = () => {
        const processedData = indivisualBids.map((bid) => {
            return {
                name: lodashGet(instances, bid.instanceId),
                capacity: {
                    primary: lodashGet(bid, ['primary', 'capacity'], []),
                    secondary: lodashGet(bid, ['secondary', 'capacity'], []),
                },
            };
        });
        setCapacity(processedData);
    };

    return (
        <div className={`${bidClasses.InfoModalContainer}`} style={{ width: 'auto' }}>
            <div>
                <div className={bidClasses.InfoModalHeading}>
                    <Typography content={'Overall Bid Capacity'} size={14} />
                </div>
                <div className={bidClasses.TableContainer}>
                    {columns.map((column, colIndex) => (
                        <table key={colIndex}>
                            <thead>
                                <tr>
                                    <th>Slot</th>
                                    <th>Hour</th>
                                    <th>Capacity</th>
                                </tr>
                            </thead>
                            <tbody>
                                {column.map((key) => (
                                    <tr key={key}>
                                        <td>{key + 1}</td>
                                        <td>
                                            {momentTimeFormater(bidDate).add(key, 'hour').hour()}-
                                            {momentTimeFormater(bidDate)
                                                .add(key + 1, 'hour')
                                                .hour()}
                                        </td>
                                        <td className={bidClasses.Flex} style={{ gap: '0.2vw' }}>
                                            {lodashGet(data, ['overall', key])}
                                            <CustomTooltip content={'Out of market'}>
                                                <span className="required">{panicHours.includes(`HOUR__${key}`) ? '*' : ''}</span>
                                            </CustomTooltip>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    ))}
                </div>

                {capacity.map((item, index) => (
                    <div key={index}>
                        <div className={bidClasses.InfoModalHeading}>
                            <Typography content={item.name} size={14} />
                        </div>

                        <div className={bidClasses.TableContainer}>
                            {columns.map((column, colIndex) => (
                                <table key={colIndex}>
                                    <thead>
                                        <tr>
                                            <th>Slot</th>
                                            <th>Hour</th>
                                            <th>Capacity (Pri/Sec)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {column.map((key) => (
                                            <tr key={key}>
                                                <td>{key + 1}</td>
                                                <td>
                                                    {momentTimeFormater(bidDate).add(key, 'hour').hour()}-
                                                    {momentTimeFormater(bidDate)
                                                        .add(key + 1, 'hour')
                                                        .hour()}
                                                </td>
                                                <td>{`${lodashGet(item, ['capacity', 'primary', key], '--')} / ${lodashGet(item, ['capacity', 'secondary', key], '--')}`}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default BundleBidCapacity;
